import {isMobile} from "@/utils/features";

export default function (dom, opts) {
	var options = {
		classes: {
			showOverlay: 'contact-overlay',
			showLoginOverlay: 'login-overlay',
			showCrawlerOverlay: 'show--crawler',
			closeOverlay: 'close-box',
		},
		showCo2Overlay: false
		,
		selectors: {
			toggleOverlay: '[data-contact]',
			toggleOverlayContact: '[data-contactelement]',
			toggleOverlayWidget: '[data-contact-widget]',
			toggleLoginOverlay: '[data-login]',
			toggleCrawlerOverlay: '[data-crawler-toggle]',
      closeCrawler: '[data-close-crawler]',
			toggleLogoutOverlay: '[data-logout]',
			boxClose: '[data-close-box]',
      productNameFormSel: '[name="productname"]',
			titleSel: '[data-product-offer-title]',
		},

		...opts
	};

	console.info("classes", options.classes.showOverlay);

	const html = document.documentElement;
	const body = document.body;
  const productNameInForm = body.querySelector(options.selectors.productNameFormSel);
	const formTitle = body.querySelector(options.selectors.titleSel);
	const crawlerSelector = dom.querySelector(options.selectors.toggleCrawlerOverlay);
	const contactBtn = document.querySelectorAll(options.selectors.toggleOverlayContact);
	const toggleHandle = dom.querySelector("[data-toggle-handle]")

	init()

	function init() {

		if(options.showCo2Overlay) {
			toggleHandle.addEventListener('click', onToggle);
		} else {
			if (null !== document.querySelector(options.selectors.toggleOverlay)) {
				document.querySelector(options.selectors.toggleOverlay).addEventListener('click', onToggle);
			}
			document.querySelector(options.selectors.toggleOverlayWidget).addEventListener('click', onToggle);
			document.querySelector(options.selectors.closeCrawler).addEventListener('click', closeCrawler);

			if (crawlerSelector) {
				crawlerSelector.addEventListener('click', toggleCrawlerOpen);
			}

			if (contactBtn) {
				contactBtn.forEach(function(el){
					el.addEventListener('click', onToggle);
				});
			}
		}
		Array.from(document.querySelectorAll(options.selectors.boxClose)).forEach(el => {
			el.addEventListener('click', onClose);
		});
	}

	function onToggle(e) {
		console.log(options.classes.showOverlay);

		e.preventDefault();
		if (html.classList.contains(options.classes.showOverlay)) {
			onClose();
		}
		else {
			onOpen();
		}
	}

	function onOpen() {
		html.classList.add(options.classes.showOverlay);
	}

	function onClose() {
		html.classList.remove(options.classes.showOverlay);
    productNameInForm.value = '';

		if (formTitle) {
			formTitle.innerHTML = formTitle.getAttribute('data-default-title');
		}

		if (html.classList.contains(options.classes.showLoginOverlay)) {
			html.classList.remove(options.classes.showLoginOverlay);
		}
	}

    function toggleCrawlerOpen() {
        html.classList.toggle(options.classes.showCrawlerOverlay);
    }

    function closeCrawler() {
        html.classList.remove(options.classes.showCrawlerOverlay);
    }

    function onOuterClick(e) {
        if (!isMobile() && !dom.contains(e.target)) {
            closeCrawler()
        }
    }
}
